<template>
    <div>
        <template v-if="lista.place">
            <ProcesoCompraAbonadosSga v-if="teatro.sga" ref="cambioRuta"/>
            <ProcesoCompraAbonadoLfp v-else-if="manager.lfp && url.includes('test=true')"/>
            <ProcesoCompraAbonadoNormal v-else/>
        </template>
        <ProcesoCompraAbonadosSinRecinto v-else/>
    </div>
</template>

<script>
    import ProcesoCompraAbonadoNormal from '@/components/frontend/abonos/nuevo/ProcesoCompraAbonadoNormal';
    import ProcesoCompraAbonadoLfp from '@/components/frontend/abonos/nuevo/ProcesoCompraAbonadoLfp';
    import ProcesoCompraAbonadosSga from '@/components/frontend/abonos/sga/ProcesoCompraAbonadosSga.vue';
    import ProcesoCompraAbonadosSinRecinto from '@/components/frontend/abonos/nuevo/ProcesoCompraAbonadosSinRecinto.vue';

    export default {
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            url() {
                return window.location.href;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            lista() {
                return this.$store.getters.getListaAbonados;
            },
            puede_acceder() {
                if (this.$route.query.n_abonado_antiguo != null && this.$route.query.dni) {
                    if (this.manager.renovar_abono) {
                        return true;
                    }
                }

                if (this.manager.nuevo_abono) {
                    return true;
                }

                return false;
            }
        },
        components: {
            ProcesoCompraAbonadoNormal, ProcesoCompraAbonadoLfp, ProcesoCompraAbonadosSga, ProcesoCompraAbonadosSinRecinto
        },
        created() {
            let super_hiper_acceso = this.$route.query.super_hiper_acceso
            if(!this.puede_acceder && !(super_hiper_acceso === "si")) {
                this.$router.push({ name: 'front.home' });
            }
        },
        beforeRouteLeave(to, from, next) {
            if(this.teatro.sga) {
                this.$refs.cambioRuta.eliminarDatos();
            }
            
            next();
        }
    }
</script>